/**
 * Created by houyulei on 2016/5/17.
 */
import $ from 'jquery';
import ajax from 'util/ajax';
import {in_array, isArray} from 'util/array.js';
export const ajaxStoreName = 'ajaxData';
export const REQUEST_DATA = 'REQUEST_DATA';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const EXPIRED_DATA = "EXPIRED_DATA";
export const RECEIVE_ERROR = 'RECEIVE_ERROR';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';

//meta:{viewName,viewItemKey,viewItemsKey,api}

export function requestData(meta, params) {
    return {
        type: REQUEST_DATA, meta, params
    }
}

export function receiveData(meta, params, result) {
    return {
        type: RECEIVE_DATA, meta, params, result
    }
}

export function receiveError(meta, result) {
    return {type: RECEIVE_ERROR, meta, result};
}

export function updateItem(meta, item) {
    return {type: UPDATE_ITEM, meta, item}
}
export function deleteItem(meta, item) {
    return {type: DELETE_ITEM, meta, item}
}

export function expiredData(meta) {
    return {type: EXPIRED_DATA, meta}
}

function fetchData(meta, params) {
    return function (dispatch) {
        dispatch(requestData(meta, params));
        ajax({
            type: 'get',
            dataType: 'json',
            url: meta.api,
            data: params,
            success: function (result) {
                if (result && result.code == 0) {
                    var obj = result;
                    if (meta.viewItemsKey) {
                        if (isArray(result[meta.viewItemsKey])) {
                            obj.items = result[meta.viewItemsKey];
                        } else {
                            obj.items = [result[meta.viewItemsKey]]
                        }
                    } else if (meta.getViewItems) {
                        obj.items = meta.getViewItems(result);
                    }
                    dispatch(receiveData(meta, params, obj));
                } else {
                    dispatch(receiveError(meta, {
                        code: '50x',
                        message: '服务器出错了'
                    }));
                }
            },
            error: function (xhr) {
                try {
                    var responseJSON = xhr.responseJSON;
                    dispatch(receiveError(meta, responseJSON));
                } catch (e) {
                    dispatch(receiveError(meta, {
                        Code: '50x',
                        Message: '服务器出错了'
                    }));
                }
            }
        });
    }
}

function shouldFetchData(state, meta, params = {}) {
    var {viewName, viewItemKey = 'id'} = meta;
    var model = state[ajaxStoreName][viewName];
    var result = true;
    if (model) {
        var oldMeta = model.meta;
        if (params && params[viewItemKey]) {//查询单个item
            if (model.currentItem && model.currentItem.item && model.currentItem.item[viewItemKey] == params[viewItemKey]) {
                result = false;
            } else if (model.items && model.items.length) {
                var index = in_array(model.items, params[viewItemKey], viewItemKey);
                if (index > -1) {
                    result = false;
                }
            } else {
                result = !model.fetching;
            }
        } else if (oldMeta && oldMeta.api == meta.api) {
            var oldParams = $.extend({page: 1}, model.params), newParams = $.extend({page: 1}, params);
            if ($.param(oldParams) === $.param(newParams)) {
                result = false;
            }
        }
    }

    return result;
}

export function fetchDataIfNeeded(meta, params) {
    return function (dispatch, getState) {
        if (!shouldFetchData(getState(), meta, params)) {
            return Promise.resolve()
        } else {
            return dispatch(fetchData(meta, params));
        }
    }
}

export function getItemById(data, meta, params) {
    var {viewItemKey = 'id'} = meta;

    if (!data || data.fetching || (!data.fetching && !data.items && !data.error)) {
        return {fetching: true};
    }
    var {currentItem} = data;
    if (currentItem && currentItem.item && currentItem.item[viewItemKey] == params[viewItemKey]) {
        return currentItem.item;
    }

    var index = in_array(data.items, params[viewItemKey], viewItemKey);
    if (index > -1) {
        return data['items'][index];
    }
    return data;
}


// WEBPACK FOOTER //
// ./components/redux/ajax/action.js